import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

/**
 * Returns the browser's current absolute URL. Automatically updates whenever
 * the React-Router location changes, making it safe to use in share controls
 * or analytics events.
 */
export const useShareUrl = (): string => {
  const location = useLocation();

  return useMemo(() => {
    if (typeof window === 'undefined') return '';
    return window.location.href;
  }, [location]);
}; 